import { BUSCAR_DETALHAMENTO_FINANCEIRO_ITINERARIO } from '../../actions/types'

const initialState = undefined

export default function reducerDetalhamentoFinanceiroItinerario (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_DETALHAMENTO_FINANCEIRO_ITINERARIO: {
      const detalhamentos = action.payload.data;

      if (detalhamentos) {
        return detalhamentos.sort((n1, n2) => {
          if (n1.vendedor > n2.vendedor) {
            return 1;
          }

          if (n1.vendedor < n2.vendedor) {
            return -1;
          }

          return 0;
        });
      }
      return []
    }
    default: {
      return state
    }
  }
}
